interface eSignaturePayload {
    Platform: string;
    orderId: string;
}

export const eSignatureURL = async ({ payload }: { payload: eSignaturePayload }) => {
    try {
        const url = `${process.env.API_BASE_URL}/orobonds/digio/esigningUrlForUnlistedEquities`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-product": "orobonds:default",
            },
            body: JSON.stringify(payload),
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const eSignStatus = async ({ payload }: { payload: eSignaturePayload }) => {
    console.log("In Esign : ", payload);
    try {
        const url = `${process.env.API_BASE_URL}/orobonds/digio/v2/eSignStatus`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-product": "orobonds:default",
            },
            body: JSON.stringify(payload),
            credentials: "include",
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};
